// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputModal__inputContainer___PQTcT","buttonsContainer":"InputModal__buttonsContainer___Z3YdE"};